<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <navigation
            :list="segments"
            :active-value="activeSegment"
            variety="segmented"
            @active:updated="updateActiveSegment"
          />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <keep-alive>
            <component :is="activeSegmentComponent" />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Navigation from '~components/common/Navigation'
import EnterpriseAccountSettings from './nested/AccountSettings'
import EnterpriseEnrolledEvents from './nested/EnroledlEvents'
import EnterpriseManagingJobOpenings from './nested/ManagingJobOpenings'
export default {
  name: 'EnterprisesIndexContent',
  components: {
    Navigation,
    EnterpriseAccountSettings,
    EnterpriseEnrolledEvents,
    EnterpriseManagingJobOpenings
  },
  data () {
    return {
      segments: ['資料管理', '職缺管理', '活動專區'],
      segmentComponents: [EnterpriseAccountSettings, EnterpriseManagingJobOpenings, EnterpriseEnrolledEvents],
      activeSegment: '資料管理'
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseGetter'
    ]),
    activeSegmentComponent () {
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    }
  },
  async created () {
    const specificSegment = this.$route.query.tab
    if (specificSegment) {
      this.updateActiveSegment(specificSegment)
    }
    this.togglePageLoader(true)
    if (Object.keys(this.currentEnterpriseGetter).length < 1) {
      await this.getEnterpriseByToken()
    }
    await this.getEnterpriseInternForm()
    this.togglePageLoader(false)
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getEnterpriseByToken',
      'getEnterpriseInternForm',
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    updateActiveSegment (segment) {
      this.activeSegment = segment
      this.$router.push({
        path: '/enterprises',
        query: {
          tab: segment
        }
      })
    }
  }
}
</script>
